import { FileText, Download } from 'lucide-react';
import type { Message } from '../../../api/chat';
import { BASE_URL, fmtFileSize } from '../utils/format';

function AttachmentBubble({ att, isMine }: { att: NonNullable<Message['attachments']>[0]; isMine: boolean }) {
  const url = `${BASE_URL}${att.file_url}`;

  if (att.mime_type?.startsWith('image/')) {
    return (
      <div className="relative group rounded-xl overflow-hidden max-w-[260px]">
        <img src={url} alt={att.file_name} className="w-full object-cover rounded-xl" />
        <a href={url} download={att.file_name} target="_blank" rel="noreferrer"
          className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition flex items-center justify-center">
          <Download size={20} className="text-white opacity-0 group-hover:opacity-100 transition drop-shadow" />
        </a>
      </div>
    );
  }

  return (
    <a href={url} target="_blank" rel="noreferrer" download={att.file_name}
      className={`flex items-center gap-3 p-3 rounded-xl max-w-[240px] transition ${
        isMine ? 'bg-blue-500/30 hover:bg-blue-500/40' : 'bg-gray-100 hover:bg-gray-200'
      }`}>
      <div className={`p-2 rounded-lg ${isMine ? 'bg-white/20' : 'bg-white'} shadow-sm flex-shrink-0`}>
        <FileText size={18} className={isMine ? 'text-white' : 'text-blue-600'} />
      </div>
      <div className="min-w-0 flex-1">
        <p className={`text-xs font-medium truncate ${isMine ? 'text-white' : 'text-gray-800'}`}>{att.file_name}</p>
        <p className={`text-[10px] mt-0.5 ${isMine ? 'text-blue-100' : 'text-gray-400'}`}>{fmtFileSize(att.file_size)}</p>
      </div>
      <Download size={14} className={isMine ? 'text-blue-100 flex-shrink-0' : 'text-gray-400 flex-shrink-0'} />
    </a>
  );
}

export default AttachmentBubble;
